import { render } from "./GMapMarkers.vue?vue&type=template&id=0c2f1952"
import script from "./GMapMarkers.vue?vue&type=script&lang=js"
export * from "./GMapMarkers.vue?vue&type=script&lang=js"

import "./GMapMarkers.vue?vue&type=style&index=0&id=0c2f1952&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__